import { Provider } from "../../Context";
import TarefaList from "./List";
import { Actions } from "./Actions";
import Form from "./Form";

function AppTarefa() {
  const data = Actions();
  return (
    <Provider value={data}>
      <div className="App">
        <h1>Tarefas</h1>
        <ul class="collapsible">
          <li>
            <div class="collapsible-header"><i class="material-icons">add</i>Nova tarefa</div>
            <div class="collapsible-body">
              <div className="row">
                <Form />
              </div>
            </div>
          </li>
          <li class="active">
            <div class="collapsible-header"><i class="material-icons">search</i>Lista de tarefas</div>
            <div class="collapsible-body">
              <div className="row">
                <TarefaList />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Provider>
  );
}

export default AppTarefa;